import { AppStateType } from 'reducers';
import { Selector, createSelector } from '@reduxjs/toolkit';
import { CsmState } from '../reducers/csm';

const getCsmState: Selector<AppStateType, CsmState> = (state) => state.csmReducer;

export const getIsLoadingCsm: Selector<AppStateType, boolean> = (state) => {
  const csmState = getCsmState(state);
  return csmState.isLoading;
};

export const getCsmLoaded: Selector<AppStateType, boolean> = (state) => {
  const csmState = getCsmState(state);
  return csmState.isLoaded;
};

export const getCsmAssignmentbyTeam = createSelector(
  getCsmState,
  (state) => state.csmAssignmentByTeamHash,
);
